import EZFileLogo from '@/assets/img/ez-file-logo';
import { Flex, Image, Text } from '@mantine/core';

interface Props {
  isPartnershipPreset: boolean;
  partnership?: string;
  logoSrc?: string;
  headerText: string | null;
  descriptionText: string;
}

export const LegacyHeader = ({
  isPartnershipPreset,
  partnership,
  logoSrc,
  headerText,
  descriptionText,
}: Props) => (
  <>
    {/* Header Section */}
    <Flex
      w="100%"
      justify="space-between"
      align="center"
      mx="auto"
      direction="row"
      mb={18}
    >
      {isPartnershipPreset && <EZFileLogo />}
      {isPartnershipPreset && logoSrc && (
        <Flex
          justify="between"
          align="end"
          direction="row"
        >
          <Text
            size={11}
            c="white"
            fw={400}
            display="flex"
          >
            Included with
          </Text>
          <Image
            src={logoSrc}
            alt={`${partnership || 'Partner'} logo`}
            style={{
              width: 100,
              marginLeft: 10,
            }}
          />
        </Flex>
      )}
    </Flex>

    {/* Optional Header Text */}
    {headerText && (
      <Text
        size={18}
        c="white"
        fw={700}
        display="flex"
        mb={15}
      >
        {headerText}
      </Text>
    )}

    {/* Main Qualification Text */}
    <Text
      size={22}
      c="white"
      fw={700}
      display="flex"
    >
      You&nbsp;
      <Text
        size={22}
        c={isPartnershipPreset ? 'primary.2' : 'minor.0'}
        fw={700}
        display="contents"
        {...(isPartnershipPreset && { fs: 'italic' as const })}
      >
        should
      </Text>
      &nbsp;qualify for Financial Aid!
    </Text>

    {/* Qualification Description */}
    <Text
      size={16}
      c="white"
      mt={10}
    >
      Based on the income and household size you shared, you should qualify for Financial Aid from
      the hospital.
    </Text>

    {/* Service Description */}
    <Text
      size={16}
      c={isPartnershipPreset ? 'minor.1' : 'white'}
      mt={10}
      display="flex"
    >
      {descriptionText}
    </Text>
  </>
);
